import { useMutation } from "@tanstack/react-query";
import { SERVICE_API } from "@/lib/consts";

type RegisterAdminBody = {
	name: string;
	email: string;
	password: string;
	passwordConfirm: string;
	inviteCode: string;
};

type RegisterAdminResponse = {
	id: string;
};

export function useRegisterAdmin() {
	return useMutation({
		mutationKey: ["admin", "register"],
		mutationFn: async (data: RegisterAdminBody) => {
			const res = await fetch(`${SERVICE_API}/api/admin/register`, {
				method: "POST",
				credentials: "include",
				body: JSON.stringify(data),
				headers: {
					"Content-Type": "application/json",
				},
			});
			if (!res.ok) {
				throw new Error("Unable to register admin user");
			}

			return (await res.json()) as RegisterAdminResponse;
		},
	});
}
